import api from '../../store/config/api';
import { PROCESS_LIST as SCHEMA } from '../../schemas';

export const [
  GET_PROCESSES,
  GET_PROCESSES_REQUEST,
  GET_PROCESSES_SUCCESS,
  GET_PROCESSES_FAILURE
] = api.buildTypes('GET_PROCESSES');

export function getProcessList({ teamName, isArchived = null }) {
  return {
    type: GET_PROCESSES,
    payload: {
      url: `/teams/${teamName}/processes${
        isArchived !== null ? `?isArchived=${isArchived}` : ''
      }`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/processes.js